import { css } from '@emotion/react';
import { ScreenSize, useIsScreenSize } from '@treatwell/treatwell-aura';

export function HeaderTemplate() {
  const isSMAndUnder = useIsScreenSize(ScreenSize.SMAndUnder);

  return (
    <div
      css={css({
        height: isSMAndUnder ? 80 : 100,
        alignItems: 'center',
        display: 'flex',
        padding: isSMAndUnder ? '0 16px' : '0 40px',
      })}
    >
      <img src="logo.png" width="150" height="28" alt="logo" />
    </div>
  );
}
